<template>
	<div />
</template>
<script>
import {
	displayError, inform,
} from 'laravel-front-library';

export default {
	name: 'NotificationGenerator',
	props: {
		errors: {
			type: Array,
			default: () => [],
		},
		messages: {
			type: Array,
			default: () => [],
		},
	},
	mounted () {
		for (const message of this.messages) {
			inform(message);
		}
		for (const error of this.errors) {
			displayError(error);
		}
	},
};
</script>
